exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap&includePaths[]=/home/jenkins/work/workspace/Lumo_deploy_feature-test-3/~/breakpoint-sass/stylesheets!./src/webComponents/styles/custom/basic.nopostcss.sass
// module id = 676
// module chunks = 2